<template>
  <div class="check-box-container" :class="{'check-box-single': single}">

    <div class='pfm-checkbox' :class="{'checked': state == true}">
      <div class='box-label-wrap'>
        <div class='box' @click="changeState">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-tick'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
        </div>
        <label>Příjemce je v karanténě</label>
      </div>
    </div>

    <!-- <div class="check-filed" @click="changeState">
      <div class="field-checked" v-show="state"></div>
    </div> -->

  </div>
</template>

<script type="text/javascript">
import Langs from '@/langs'

export default {
  props: ['data', 'name', 'inner', 'single'],
  data() {
    return {
      dataChange: this.data,
      state: this.data[this.name]//true
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        console.log('Data changed')
        this.state = (this.data[this.name] !== undefined) ? this.data[this.name] : false
      }
    }
  },
  created() {
    this.state = (this.data[this.name] !== undefined) ? this.data[this.name] : false
  },
  methods: {
    changeState() {
      this.data[this.name] = (this.data[this.name] !== undefined) ? !this.data[this.name] : true
      this.state = this.data[this.name]
      this.$nextTick(() => {
        this.$emit('updated', this.name)
      })
    }
  }
};
</script>

<style>
</style>
